<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import ButtonSalva from '@/components/Generics/Buttons/ButtonSalva.vue'
import ButtonTornaAllaLista from '@/components/Generics/Buttons/ButtonTornaAllaLista.vue'

import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)

const props = defineProps(['updatePageTitle'])
const router = useRouter()

const loading = ref(true)
const newPollTitle = defineModel('newPollTitle')
const newPollDescription = defineModel('newPollDescription')
const newPollTags = defineModel('newPollTags', { default: [] })

onMounted(() => {
  props.updatePageTitle('Aggiungi template questionario')
  loading.value = false
})

async function createPollTemplate() {
  loading.value = true

  try {
    let url = `/config/templates/polls/api/poll-template/`
    await client.post(url, {
      title: newPollTitle.value,
      description: newPollDescription.value,
      tags: newPollTags.value,
      state: 'draft'
    }, 'application/json')
    loading.value = false
    toast.create('Template creato con successo', 'success')
  } catch (error) {
    loading.value = false
    toast.create('Errore nell\'invio della richiesta, riprova', 'error')
  }
}

</script>

<template>
  <div class="mt-2 p-2 card shadow-none">
    <div class="mb-3">
      <label for="pollTitle" class="form-label">Titolo *</label>
      <input
        v-model="newPollTitle"
        name="pollTitle"
        type="text"
        required
        class="form-control"
        id="pollTitle"
        placeholder="Titolo template"
      />
    </div>
    <div class="mb-3">
      <label for="pollDescription" class="form-label">Descrizione *</label>
      <textarea
        v-model="newPollDescription"
        name="pollDescription"
        class="form-control"
        required
        id="pollDescription"
      ></textarea>
    </div>
    <div class="mb-3">
      <label for="pollTags" class="form-label">Tags *</label>
      <v-select
        name="pollTags"
        id="pollTags"
        multiple
        :clearSearchOnBlur="() => true"
        taggable
        push-tags
        :options="tags"
        v-model="newPollTags"
      >
        <template #search="{attributes, events}">
          <input
            class="vs__search"
            :required="!newPollTags.length"
            v-bind="attributes"
            v-on="events"
          />
        </template>
      </v-select>
    </div>
  </div>

  <div class="d-flex justify-content-between mt-3">
    <button-torna-alla-lista @click="router.back()"></button-torna-alla-lista>
    <button-salva :loading="loading" :disabled="loading || !newPollTitle || !newPollDescription || !newPollTags.length"
                  @click="createPollTemplate"></button-salva>
  </div>

</template>

<style>
</style>
